import setPrototypeOf from "./setPrototypeOf.js";
export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/react-router-dom/~/@babel/runtime/helpers/esm/inheritsLoose.js
// module id = 1464
// module chunks = 4 5 11 15